<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("distributor", 2) }}
      </div>
      <div>
        <router-link
          class="btn-blue"
          @click.native="goToRoute('/distributor/edit-distributor')"
          to
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="distributors"
          >{{ $tc("distributor", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('distributor', 1) }} {{ $t('name') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>-->

          <div
            v-for="(item, index) in Distributors"
            :key="index"
            class="col-md-12 py-2"
          >
            <span v-if="login_user_role_id === 1">
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
            </span>
            <div
              class="row border-bottom"
              v-if="
                item.fieldname !== 'd_id' &&
                  item.fieldname !== 'created_at' &&
                  item.fieldname !== 'created_by' &&
                  item.fieldname !== 'updated_by' &&
                  item.fieldname !== 'updated_at'
              "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Distributors from "@/helper/formJSONMaster/Distributors";
import DistributorService from "@/services/DistributorService";
export default {
  components: {},
  data() {
    return {
      login_user_role_id: null,

      tableId: null,
      Distributors: [
        ...Distributors.organizations,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: null,
          type: "text"
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: "-",
          type: "text"
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: null,
          type: "text"
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: "-",
          type: "text"
        }
      ],
      submitted: false,
      Methods: Distributors.Methods,
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries"
      },
      Cities: [],
      CitiesMethod: {
        GET: "/admin/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      States: [],
      StatesMethod: {
        GET: "/admin/",
        tableName: "ms_states",
        urlKey: "states"
      }
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getViewList(id);
      this.tableId = id;
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    goToRoute: function(path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId
        }
      });
    },
    getViewList: function(id) {
      // let params = `id`
      let loader = this.$loading.show();
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Distributors.map((x, index) => {
              if (x.fieldname === "created_by") {
                this.getViewUsersDetails(
                  obj[x.fieldname],
                  index,
                  "Distributors"
                );
              } else if (x.fieldname === "updated_by") {
                this.getViewUsersDetails(
                  obj[x.fieldname],
                  index,
                  "Distributors"
                );
              } else if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
              } else if (x.type === "date") {
                x.fieldvalue = this._formatDate_dd_mm_yyyy(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            this.getContractList(obj["d_default_contract"]);
            this.getCountryList(obj.country_id);
            this.getStatesList(obj.state_id);
            this.getCitiesList(obj.city_id);
            this.getDistributorList(obj.parent_distributor_id);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
          setTimeout(() => {
            loader.hide();
          }, 100);
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getDistributorList: function(id) {
      console.log("id :", id);
      let loader = this.$loading.show();
      MasterService.GetDistributors()
        .then(response => {
          const { data } = response;

          if (data.Records && data.Records.length > 0) {
            this.distributorList = data.Records;

            this.distributorList.map(x => {
              if (x.d_id == id) {
                this.Distributors[2].fieldvalue = x.d_company_name;
              }
            });
          } else {
            // Show Errors
            this.$toasted.show(data.message);
          }
          setTimeout(() => {
            loader.hide();
          }, 100);
        })
        .catch(this._CatchError);
    },
    getContractList(id) {
      DistributorService.GetAllWeekWiseContractList()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.contracts = data.Records;
            this.contracts.map(x => {
              if (x.cbw_id == id) {
                this.Distributors[8].dropdownSelected =
                  x.contract_weekwise_name;
                this.Distributors[8].fieldvalue = x.contract_weekwise_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    getCountryList: function(uniqueId) {
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.setNestedDropdownFields("country_id", uniqueId, data.Records);
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getStatesList: function(uniqueId) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, this.StatesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.setNestedDropdownFields("state_id", uniqueId, data.Records);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCitiesList: function(uniqueId) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, this.CitiesMethod);
      console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.setNestedDropdownFields("city_id", uniqueId, data.Records);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getViewUsersDetails(user_id, index, key) {
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
    setNestedDropdownFields: function(name, id, array) {
      let filterObj = array.filter(x =>
        name == "currency_id" ? x["curr_id"] === id : x[name] === id
      );
      if (filterObj.length > 0) {
        this.Distributors.map(x => {
          if (name == "country_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].country_name;
          } else if (name == "state_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].state_name;
          } else if (name == "city_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].city_name;
          } else if (name == "currency_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].curr_code;
          } else if (name == "org_id" && name === x.fieldname) {
            x.fieldvalue = filterObj[0].org_name;
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorsComponents/viewDistributor.vue